const gsapController = async function () {
    const heroAnimation = document.querySelector(".home-hero") !== null;
    const pictureWrapper = document.querySelector(".picture-wrapper--animated") !== null;

    if ( heroAnimation || pictureWrapper ) {
        let gsap = await (await import('gsap')).default;

        // ScrollTrigger
        if ( heroAnimation || pictureWrapper ) {
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            gsap.registerPlugin(ScrollTrigger);

            if ( heroAnimation ) {
                let AnimatedSection = await (await import('./home-animation')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            if ( pictureWrapper ) {
                let AnimatedSection = await (await import('./image-parallax')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
        }
    }
};

export const init = gsapController;